import { render, staticRenderFns } from "./FourWidgetsSection.vue?vue&type=template&id=794abebd&"
import script from "./FourWidgetsSection.vue?vue&type=script&lang=js&"
export * from "./FourWidgetsSection.vue?vue&type=script&lang=js&"
import style0 from "./FourWidgetsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FourWidgetsSection.vue"
export default component.exports